// ============================================================
// CENTRALIZED LANDING CONTENT — single source of truth.
// Real values live in landingContent.json. That file is written directly
// by the backend when pressing "Guardar cambios en el proyecto" in
// /content-admin — this module just re-exports the same names every
// component already imports, so no component needs to change.
// ============================================================
import data from "./landingContent.json";

export const nav = data.nav;
export const hero = data.hero;
export const heroTicker = data.heroTicker;
export const vehicleBanner = data.vehicleBanner;
export const vehicleBannerPromo = data.vehicleBannerPromo;
export const stats = data.stats;
export const whyMotorPro = data.whyMotorPro;
export const carouselSection = data.carouselSection;
export const socialBoost = data.socialBoost;
export const howItWorks = data.howItWorks;
export const whatsappMock = data.whatsappMock;
export const whyPublish = data.whyPublish;
export const dealerProgram = data.dealerProgram;
export const whyApp = data.whyApp;
export const logoSection = data.logoSection;
export const finalCta = data.finalCta;

// footer.rights keeps a "{{year}}" token in the JSON so the copyright year
// always stays current without needing a resave.
export const footer = {
  ...data.footer,
  rights: data.footer.rights.replace("{{year}}", String(new Date().getFullYear())),
};
export const legalPages = data.legalPages;
